import React, { Fragment, useEffect, useState } from "react";
import AppModal from "../../common/AppModal";
import Body from "../../components/Body";
import SearchInput from "../../components/SearchInput";
import api from "../../config/api";
import useHeader from "../../hooks/useHeader";
import ContractResult from "./ContractResult";
import InvoiceResult from "./InvoiceResult";
import JobResults from "./JobResults";
import TaskResults from "./TaskResults";
import { observer } from "mobx-react-lite";
import { getPos } from "../../stores/PoStore";
import { getJobs } from "../../stores/JobStore";
import { useQuery } from "@tanstack/react-query";
import { getOrganizations } from "../../stores/OrganizationStore";
import { getLocations } from "../../stores/LocationStore";
import { getContracts } from "../../stores/ContractStore";
import { getTasks } from "../../stores/TaskStore";
import { getContractInvocies } from "../../stores/ContractInvocieStore";

const Index = (props) => {
  const { setHeader } = useHeader();
  const [isAdvance, setIsAdvance] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [contractsInvoices, setContractsInvoices] = useState([]);

  const onCheckChange = (e) => setIsAdvance(e.target.checked);

  const { data: pos, isFetching: isFetchingPos } = useQuery({
    queryFn: () => getPos({ advance: isAdvance }),
    queryKey: isAdvance ? ["pos", "advance"] : ["pos"],
  });

  const { data: tasks, isFetching: isFetchingTasks } = useQuery({
    queryFn: () => getTasks({ advance: isAdvance }),
    queryKey: isAdvance ? ["tasks", "advance"] : ["tasks"],
  });

  const { data: contractsData, isFetching: isFetchingContracts } = useQuery({
    queryFn: () => getContracts({ advance: isAdvance }),
    queryKey: isAdvance ? ["contracts", "advance"] : ["contracts"],
  });

  const { data: jobsData, isFetching: isFetchingJobs } = useQuery({
    queryFn: () => getJobs({ advance: isAdvance }),
    queryKey: isAdvance ? ["jobs", "advance"] : ["jobs"],
  });

  const { data: organizations, isFetching: isFetchingOrganizations } = useQuery(
    {
      queryFn: () => getOrganizations(),
      queryKey: ["organizations"],
    }
  );

  const { data: locationsData, isFetching: isFetchingLocations } = useQuery({
    queryFn: () => getLocations(),
    queryKey: ["locations"],
  });

  const { data: contractInvoicesData, isFetching: isFetchingContractInvoices } =
    useQuery({
      queryFn: () => getContractInvocies({ advance: isAdvance }),
      queryKey: isAdvance
        ? ["contractInvoices", "advance"]
        : ["contractInvoices"],
    });

  // Check if any query is fetching
  const isAnyFetching =
    (!pos && isFetchingPos) ||
    (!tasks && isFetchingTasks) ||
    (!contractsData && isFetchingContracts) ||
    (!jobsData && isFetchingJobs) ||
    (!organizations && isFetchingOrganizations) ||
    (!locationsData && isFetchingLocations) ||
    (!contractInvoicesData && isFetchingContractInvoices);

  useEffect(() => {
    console.log(
      !pos && isFetchingPos,
      !tasks && isFetchingTasks,
      !contractsData && isFetchingContracts,
      !jobsData && isFetchingJobs,
      !organizations && isFetchingOrganizations,
      !locationsData && isFetchingLocations,
      !contractInvoicesData && isFetchingContractInvoices
    );
  }, [
    pos,
    isFetchingPos,
    tasks,
    isFetchingTasks,
    contractsData,
    isFetchingContracts,
    jobsData,
    isFetchingJobs,
    organizations,
    isFetchingOrganizations,
    locationsData,
    isFetchingLocations,
    contractInvoicesData,
    isFetchingContractInvoices,
  ]);

  useEffect(() => {
    const jobs = jobsData?.map((jb) => {
      return {
        ...jb,
        organization: organizations?.find(
          (item) => item._id === jb.organization
        ),
        location: jb.location?.map((i) =>
          locationsData?.find((item) => item._id === i)
        ),
      };
    });
    setJobs(jobs);
  }, [jobsData, organizations, locationsData]);

  useEffect(() => {
    const contracts = contractsData?.map((jb) => {
      return {
        ...jb,
        organization: organizations?.find(
          (item) => item._id === jb.organization
        ),
        location: jb.location?.map((i) =>
          locationsData?.find((item) => item._id === i)
        ),
      };
    });
    setContracts(contracts);
  }, [contractsData, organizations, locationsData]);

  useEffect(() => {
    const contractsInvoices = contractInvoicesData?.map((inv) => {
      return {
        ...inv,
        location: inv.contract?.location?.map((i) =>
          locationsData?.find((item) => item._id === i)
        ),
      };
    });
    setContractsInvoices(contractsInvoices);
  }, [contractInvoicesData, locationsData]);

  useEffect(() => {
    setHeader("Search");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [spinner, setSpinner] = useState(false);
  const [results, setResults] = useState();

  const findInd = (str, str2) => {
    const ind = String(str).toLowerCase().indexOf(String(str2).toLowerCase());
    return ind !== -1;
  };
  const handleSearch = async (text) => {
    if (!text) return false;
    const s = text.toLowerCase();
    setSpinner(true);

    const poResult = pos?.filter((po) => {
      return findInd(po.poNo, s);
    });

    const jobResults =
      poResult?.length > 0
        ? jobs?.filter((jb) => jb._id === poResult[0].job)
        : jobs?.filter((i) => {
            const found =
              findInd(i.jobId, s) ||
              findInd(i.invoiceID, s) ||
              findInd(i.organization?.name, s) ||
              i.location?.find((x) => findInd(x?.title, s)) ||
              i.detailsTable?.find((x) => findInd(x.serviceDescription, s));
            return found;
          }) || [];

    const contractResults = contracts?.filter((i) => {
      const found =
        findInd(i.contractId, s) ||
        findInd(i.organization?.name, s) ||
        i.location?.find((x) => findInd(x?.title, s)) ||
        i.checkListOne?.find((x) => findInd(x?.name, s)) ||
        i.checkListTwo?.find((x) => findInd(x?.name, s));
      return found;
    });

    const taskResults = tasks?.filter((i) => {
      const found =
        findInd(i.taskId, s) ||
        findInd(i.organization?.name, s) ||
        i.employee?.find(
          (x) => findInd(x?.name, s) || findInd(x.employeeId, s)
        ) ||
        findInd(i.job.jobId, s) ||
        findInd(i.contract?.contractId, s);
      return found;
    });

    const invoiceResult =
      poResult?.length > 0
        ? jobResults?.filter((jb) => jb._id === poResult[0].job)
        : jobResults?.filter((i) => {
            if (!i.invoiceCreated) return false;
            const found =
              findInd(i.invoiceID, s) ||
              findInd(i.organization?.name, s) ||
              i.location?.find((x) => findInd(x?.title, s)) ||
              i.detailsTable?.find((x) => findInd(x.serviceDescription, s));
            return found;
          });

    const contractInvoiceResult = contractsInvoices?.filter((i) => {
      const found =
        findInd(i.invoiceID, s) ||
        findInd(i.contract?.organization?.name, s) ||
        i.location?.find((x) => findInd(x?.title, s)) ||
        findInd(i.contract?.invoice_text, s);
      return found;
    });

    setResults({
      jobs: jobResults,
      invoices: [...invoiceResult, ...contractInvoiceResult],
      contracts: contractResults,
      tasks: taskResults,
    });

    setSpinner(false);
  };
  const handlePress = (key) => {
    if (key === "jobs")
      setModal({
        visible: true,
        header: "Jobs",
        body: <JobResults list={results[key]} />,
      });
    else if (key === "contracts")
      setModal({
        visible: true,
        header: "Contracts",
        body: <ContractResult list={results[key]} />,
      });
    else if (key === "invoices")
      setModal({
        visible: true,
        header: "Invoices",
        body: <InvoiceResult list={results[key]} />,
      });
    else if (key === "tasks")
      setModal({
        visible: true,
        header: "Tasks",
        body: <TaskResults list={results[key]} />,
      });
  };
  const [modal, setModal] = useState();
  return (
    <Body>
      <div style={{ position: "relative" }}>
        {/* Loading Overlay */}
        {isAnyFetching && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
              flexDirection: "column",
              gap: 20,
            }}
          >
            <div
              style={{
                width: 50,
                height: 50,
                border: "5px solid #f3f3f3",
                borderTop: "5px solid #3498db",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            />
            <div style={{ color: "white", fontSize: 18, fontWeight: "bold" }}>
              Loading Data...
            </div>
          </div>
        )}

        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <SearchInput
              spinning={spinner}
              onSubmit={handleSearch}
              placeholder="Search anything..."
              disabled={isAnyFetching}
            />
            <div style={{ display: "flex", alignItems: "center" }}>
              <input
                type="checkbox"
                id="advancedSearch"
                onChange={onCheckChange}
                checked={isAdvance}
                disabled={isAnyFetching}
                style={{ padding: 0, margin: 0, width: 50 }}
              />
              <label htmlFor="advancedSearch" style={{ marginTop: 10 }}>
                Advance Search
              </label>
            </div>
          </div>

          <br />
          {Boolean(results) && (
            <div>
              <br />
              <hr />
              <div style={{ display: "flex", gap: 40, marginTop: 40 }}>
                {Object.keys(results).map((i) => {
                  return (
                    <ResultBlock
                      onClick={() => handlePress(i)}
                      key={i}
                      title={i}
                      result={results[i]}
                    />
                  );
                })}
              </div>
            </div>
          )}
        </div>
        <AppModal
          {...modal}
          closeButton
          onHide={() => setModal({ visible: false })}
          header={<div></div>}
          size={"xl"}
        />
      </div>

      {/* CSS for spinner animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </Body>
  );
};

const ResultBlock = ({ icon, title, result, onClick }) => {
  return (
    <Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 10,
          padding: 10,
          flexDirection: "column",
          width: 200,
          backgroundColor: "#cacaca50",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <div style={{ fontSize: 30, padding: 10 }}>
          <b>{result.length}</b>
        </div>
        <div style={{ fontSize: 17, textTransform: "capitalize" }}>
          {String(title)}
        </div>
      </div>
    </Fragment>
  );
};

export default observer(Index);
